import React from 'react'

import shapes from '@digital-twins/slide-schemas/layouts/shapes.json'
import type { PlotSlot } from '@digital-twins/slide-schemas/generated/plot-types'

/** A deck plot slot shape: a `PlotSlot` with pixels (`card` is responsive and has none). */
export type SlotPlotShape = Exclude<PlotSlot, 'card'>

/**
 * The plot slot (plots plan Stage 2, AA): the panel a slide's plot is drawn in, sized by
 * its shape from `shapes.json` (the one owner of slot pixels) and placed by the host.
 * The host nests its `PlotBox` inside (the figure that swaps in a segment cut when the gear
 * picks one); the slot adds only the shape. It is absolutely placed, as the rail
 * layouts place it; a flow layout's plot (stage) needs an in-column variant (Step 7).
 */
export interface SlotPlotProps {
  shape: SlotPlotShape
  x: number
  y: number
  testId?: string
  /** The panel's own look (radius, fill, overflow); its size and place are the slot's. */
  style?: Omit<React.CSSProperties, 'position' | 'left' | 'top' | 'width' | 'height'>
  children: React.ReactNode
}

export function SlotPlot(props: SlotPlotProps) {
  const { shape, x, y, testId, style, children } = props
  const { w, h } = shapes[shape]
  return (
    <section data-testid={testId} style={{ position: 'absolute', left: x, top: y, width: w, height: h, ...style }}>
      {children}
    </section>
  )
}
